import Header from "../../../componente/header";
import "./style.css";

// componentes (todos dentro de ./componentes)
import ClientesCard from "./componentes/ClientesCard";
import FichasBarChart from "./componentes/FichasBarChart";
import PanoBarChart from "./componentes/PanoBarChart";
import EquipeRanking from "./componentes/EquipeRanking";
import VendedorRanking from "./componentes/VendedorRanking";
import ClienteRanking from "./componentes/ClienteRanking";
import TipoPieChart from "./componentes/TipoPieChart";

function Home() {
  return (
    <>
      <Header />

      <div className="dashboard-container">

        {/* ===== LINHA 1: 3 CARDS (Total / Ativos / Inativos) ===== */}
        <div className="row g-3 mb-3">
          <div className="col-12">
            {/* ClientesCard recebe props: tipo (para API) e titulo (texto do header) */}
            <ClientesCard />
          </div>          
        </div>

        {/* ===== LINHA 2: Fichas + 3 Rankings (4 colunas) ===== */}
        <div className="row g-3 mb-3">
          <div className="col-12 col-md-3">
            <FichasBarChart />
          </div>

          <div className="col-12 col-md-3">
            <EquipeRanking />
          </div>

          <div className="col-12 col-md-3">
            <VendedorRanking />
          </div>

          <div className="col-12 col-md-3">
            <ClienteRanking />
          </div>
        </div>

        {/* ===== LINHA 3: Pano e Tipos (cada um ocupa metade da largura) ===== */}
        <div className="row g-3">
          <div className="col-12 col-md-6">
            <PanoBarChart />
          </div>

          <div className="col-12 col-md-6">
            <TipoPieChart />
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
